export default (assetsBaseUrl = '/'): string => `
@font-face {
    font-family: Bryant;
    font-weight: 400;
    src: url('${assetsBaseUrl}fonts/bryant/bryant-regular.woff2') format('woff2'),
         url('${assetsBaseUrl}fonts/bryant/bryant-regular.woff') format('woff');
}

@font-face {
    font-family: Bryant;
    font-weight: 600;
    src: url('${assetsBaseUrl}fonts/bryant/bryant-semibold.woff2') format('woff2'),
         url('${assetsBaseUrl}fonts/bryant/bryant-semibold.woff') format('woff');
}

@font-face {
    font-family: Bryant;
    font-weight: 700;
    src: url('${assetsBaseUrl}fonts/bryant/bryant-bold.woff2') format('woff2'),
         url('${assetsBaseUrl}fonts/bryant/bryant-bold.woff') format('woff');
}

@font-face {
    font-family: 'Open Sans';
    font-weight: 400;
    src: url('${assetsBaseUrl}fonts/opensans/opensans-regular.woff2') format('woff2'),
         url('${assetsBaseUrl}fonts/opensans/opensans-regular.woff') format('woff');
}

@font-face {
    font-family: 'Open Sans';
    font-weight: 600;
    src: url('${assetsBaseUrl}fonts/opensans/opensans-semibold.woff2') format('woff2'),
         url('${assetsBaseUrl}fonts/opensans/opensans-semibold.woff') format('woff');
}
`
